export const development = {
      sharedUi: 'Shared UI',
      sampleInput: 'Sample value',
      sampleTextarea: 'Long-text field example.',
      codePlaceholder: 'ABC-1234',

      title: 'Technical catalog',
      subtitle: 'Internal technical catalog of system components and wrappers.',
      componentsTitle: 'Components',
      componentsDescription: 'Unified technical catalog of components sorted by status, with completed items first.',
      previewLabel: 'Preview',
      primaryExample: 'Primary',
      secondaryExample: 'Secondary',
      ghostExample: 'Ghost',
      dangerExample: 'Danger',
      iconOnlyExample: 'Icon',
      buttonPreview: 'Base wrapper variants for primary system actions.',
      metricCardPreview: 'Compact card to validate KPIs and summary blocks inside the layout.',
      segmentedControlPreview: 'Reusable control to switch between technical views inside a screen.',
      showcaseCardPreview: 'Example of the reusable panel with title, description, badge, and flexible bottom area.',
      formFieldPreview: 'Shared wrapper for label, hint, and error around a control.',
      inputPreview: 'Reusable field connected to reactive forms and ngModel.',
      selectPreview: 'Reusable select with the same visual density as the system.',
      errorMessagePreview: 'Base message component for validations and form errors.',
      sidebarPreview: 'Currently used in the authenticated shell side navigation.',
      languageSwitcherPreview: 'Available in sidebar and login for quick language switching.',
      paginationPreview: 'Used in administrative tables with page and rows-per-page controls.',
      dataTablePreview: 'Reusable shell for administrative tables with action, content, and pagination slots.',
      dataTableSampleDescription: 'Base view to catalog shared pieces with table content and page controls.',
      tableCode: 'Code',
      tableComponent: 'Component',
      tableFamily: 'Family',
      modalPreview: 'Reusable shell for overlays with header, body, and footer actions.',
      datePickerPreview: 'Pending lightweight external library selection and wrapper.',
      modalVariantAcceptCancel: 'Accept / Cancel',
      modalVariantAcceptOnly: 'Accept only',
      modalVariantSaveCancel: 'Save / Cancel',
      modalVariantDanger: 'Confirm / Cancel',
      modalAcceptCancelTitle: 'Confirm action',
      modalAcceptCancelSubtitle: 'Base preset for simple system confirmations.',
      modalAcceptCancelBody: 'Use this preset when the flow needs a simple confirmation with positive and negative exits.',
      modalAcceptOnlyTitle: 'Information',
      modalAcceptOnlySubtitle: 'Base preset for informational messages without destructive action.',
      modalAcceptOnlyBody: 'This preset works for notices or passive confirmations where only one primary exit is needed.',
      modalSaveCancelTitle: 'Save changes',
      modalSaveCancelSubtitle: 'Recommended preset for editable modal forms.',
      modalSaveCancelBody: 'Use this preset when the modal contains a form and the primary CTA persists changes.',
      modalDangerTitle: 'Delete mock record',
      modalDangerSubtitle: 'Preset for sensitive or risky actions.',
      modalDangerBody: 'This preset makes the destructive nature of the action explicit and reinforces the cancel path.',
      sidebarTitle: 'Sidebar',
      sidebarDescription: 'Responsive side navigation with collapsed mode, tooltips, and access to the main ERP areas.',
      languageSwitcherTitle: 'Language switcher',
      languageSwitcherDescription: 'Reusable language selector for sidebar, login, and compact views.',
      paginationTitle: 'Table pagination',
      paginationDescription: 'Shared paginator for admin tables with rows-per-page selector.',
      dataTableTitle: 'Data table',
      dataTableDescription: 'Reusable container for actions, table content, empty states, and pagination in one piece.',
      modalTitle: 'Current modal base',
      modalDescription: 'Base shell for modals with title, subtitle, projected content, and actions.',
      buttonTitle: 'Button wrapper',
      buttonDescription: 'Base component for primary, secondary, danger, and disabled/loading states.',
      metricCardTitle: 'Metric card',
      metricCardDescription: 'Simple card for dashboard KPIs with label, value, and trend.',
      metricCardSampleLabel: 'Shared components',
      badgeTitle: 'Badge',
      badgeDescription: 'Generic component for short states, labels, and reusable visual markers.',
      badgePreview: 'Base badge with reusable tones for visual states across the system.',
      badgeNeutralExample: 'Neutral',
      badgeSuccessExample: 'Success',
      badgeWarningExample: 'Warning',
      badgeDangerExample: 'Critical',
      badgeInfoExample: 'Info',
      listPanelTitle: 'List panel',
      listPanelDescription: 'Reusable container to group descriptive items into internal rows with a trailing action.',
      listPanelPreview: 'Reusable list panel for grouped settings, catalogs, or parameters.',
      listPanelSampleTitle: 'Reusable blocks',
      listPanelSampleDescription: 'Groups related entries inside a single surface.',
      listPanelRowOneTitle: 'Shared layout',
      listPanelRowOneDescription: 'Minimal reference to list visual pieces with a trailing action.',
      segmentedControlTitle: 'Segmented control',
      segmentedControlDescription: 'Pill-style selector to switch views or states within a screen.',
      segmentedOptionOverview: 'Overview',
      segmentedOptionDetails: 'Details',
      showcaseCardTitle: 'Showcase card',
      showcaseCardDescription: 'Reusable panel for internal documentation, visual reports, and actionable catalogs.',
      sampleTitle: 'Sample title',
      sampleDescription: 'Short description of the documented component or module.',
      formFieldTitle: 'Form field wrapper',
      formFieldDescription: 'Shared container for label, required, hint, and error messages.',
      formFieldSampleLabel: 'Sample email',
      inputTitle: 'Input wrapper',
      inputDescription: 'Base field for text, email, password, and number with Reactive Forms integration.',
      selectTitle: 'Select wrapper',
      selectDescription: 'Standard select with the same density and visual states as the system.',
      textareaTitle: 'Textarea wrapper',
      textareaDescription: 'Reusable multiline field for notes, observations, and operational comments.',
      textareaPreview: 'Textarea connected to the same visual language as the system.',
      checkboxTitle: 'Checkbox wrapper',
      checkboxDescription: 'Reusable control for boolean options and simple settings.',
      checkboxPreview: 'Base checkbox with integrated label and form support.',
      checkboxExample: 'Send welcome email',
      radioGroupTitle: 'Radio group wrapper',
      radioGroupDescription: 'Reusable selector for mutually exclusive options with form support.',
      radioGroupPreview: 'Visual option group to choose a single value from a set.',
      switchTitle: 'Switch wrapper',
      switchDescription: 'Reusable control to enable or disable a preference with switch semantics.',
      switchPreview: 'Base switch for binary settings and quick preferences.',
      switchExample: 'Enable operational notifications',
      switchExampleHint: 'Example of a binary preference with form support.',
      formSectionTitle: 'Form section',
      formSectionDescription: 'Semantic container to group related fields with title and description.',
      formSectionPreview: 'Reusable section to structure complex forms into clear blocks.',
      formSectionExampleTitle: 'General data',
      formSectionExampleDescription: 'Groups related fields inside the same semantic block.',
      formSectionExampleHint: 'Example of contextual help inside a section.',
      errorMessageTitle: 'Error message',
      errorMessageDescription: 'Lightweight component to render validation feedback consistently.',
      datePickerTitle: 'Date picker',
      datePickerDescription: 'Future wrapper for a lightweight date library without depending on Angular Material.',
      optionPrimary: 'Primary',
      optionPrimaryHint: 'Baseline configuration with the highest visual emphasis.',
      optionSecondary: 'Secondary',
      optionSecondaryHint: 'More neutral configuration for supporting actions.',
      optionCompact: 'Compact',
      optionCompactHint: 'Configuration intended for toolbars or tighter layouts.',
      statusReady: 'Ready',
      statusInUse: 'In use',
      statusPlanned: 'Planned',
      statusResearch: 'Research',
    } as const;
